<template>
  <div class="page--full job-apply">
    <el-row type="flex" class="row--full flex-wrap job-apply__wrapper">
      <el-col :sm="12" :lg="15" class="job-apply__header">
        <h1 class="header__wrapper">
          <span class="header">Interested? <br />You know what to do</span>
        </h1>
        <p class="subheader">
          No need to be formal. Just <a href="mailto:hello@sodalabs.co">send us</a> your links and
          we'll be in touch.
        </p>
      </el-col>
      <el-col :sm="12" :lg="9" class="job-apply__form">
        <el-form
          ref="jobApplyForm"
          class="form"
          name="career-application"
          action="/"
          :model="jobApplyForm"
          :rules="rules"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          @submit.prevent.native="handleSubmit"
        >
          <el-input type="hidden" name="bot-field" />
          <el-form-item prop="job">
            <el-select v-model="jobApplyForm.job" placeholder="Select" style="width: 100%;">
              <el-option v-for="item in jobOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item prop="name">
            <el-input v-model="jobApplyForm.name" name="name" type="text" placeholder="Your name" />
          </el-form-item>
          <el-form-item prop="email">
            <el-input
              v-model="jobApplyForm.email"
              name="email"
              type="email"
              placeholder="Your fancy email"
            />
          </el-form-item>
          <el-form-item prop="resume">
            <el-input
              v-model="jobApplyForm.resume"
              name="resume"
              type="text"
              placeholder="Your beautiful resume link"
            />
          </el-form-item>
          <el-form-item prop="content" class="form__textarea">
            <el-input
              v-model="jobApplyForm.content"
              name="content"
              :rows="4"
              type="textarea"
              placeholder="Talk to us..."
            />
          </el-form-item>
          <el-form-item>
            <button
              type="submit"
              class="form__submit btn btn--secondary btn--bounce is-flex middle"
            >
              <span>Send</span>
              <img src="@/assets/images/icons/arrow.svg" />
            </button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';

import careerData from '@/assets/json/career.json';

export default {
  created() {
    const id = this.$route.params.id;
    this.jobOptions = careerData.ids.map(item => careerData.data[item].content.name);
    this.jobApplyForm.job = careerData.data[id].content.name;
  },
  name: 'job',
  data() {
    return {
      jobOptions: [],
      jobApplyForm: {
        job: '',
        name: '',
        email: '',
        content: '',
      },
      rules: {
        job: [{ required: true, message: 'Please choose a career type.', trigger: 'blur' }],
        name: [{ required: true, message: 'Please fill in your name.', trigger: 'blur' }],
        email: [{ required: true, message: 'Please fill in your email.', trigger: 'blur' }],
        content: [{ required: true, message: 'Please introduce yourself.', trigger: 'blur' }],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.jobApplyForm.validate(async valid => {
        if (valid) {
          const encodedData = qs.stringify({
            ...this.jobApplyForm,
            'form-name': 'career-application',
          });
          const options = {
            header: { 'Content-Type': 'application/x-www-form-urlencoded' },
          };
          try {
            await axios.post('/', encodedData, options);
          } catch (e) {
            console.log(e);
          }
          this.$router.push({ name: 'submitted' });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.job-apply {
  display: flex;
  align-items: center;
  justify-content: center;
  &__wrapper {
    padding: 6.375rem 2rem 0;
    @media (min-width: $sm) {
      padding: 8.75rem 8.125rem 0;
    }
    @media (min-width: $xl) {
      padding: 14rem 12rem 0;
    }
  }
  &__header {
    @media (min-width: $sm) {
    }
  }
  &__form {
    @media (min-width: $sm) {
    }
  }
}

.header {
  &__wrapper {
    padding-top: 1.5rem;
    margin: 0;
    margin-bottom: 1rem;
    white-space: nowrap;
    @media (min-width: $sm) {
    }
  }
}

.form {
  &__submit {
    @media (min-width: $sm) {
      width: 60%;
    }
  }
  &__textarea {
    margin-bottom: 1.5rem;
  }
}

.subheader {
  color: $color-secondary;
  font-size: 1rem;
  font-weight: 400;
  opacity: 0.5;
  @media (min-width: $sm) {
    font-size: 1.25rem;
  }
  a {
    color: $color-secondary;
    text-decoration: none;
    border-bottom: 1px solid $color-secondary;
  }
}
</style>
